import { render, staticRenderFns } from "./AddUserByEmail.vue?vue&type=template&id=2b587286&"
import script from "./AddUserByEmail.vue?vue&type=script&lang=js&"
export * from "./AddUserByEmail.vue?vue&type=script&lang=js&"
import style0 from "./AddUserByEmail.vue?vue&type=style&index=0&id=2b587286&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports